import { render, staticRenderFns } from "./display-field-mandate.vue?vue&type=template&id=ccef41b4&scoped=true&"
import script from "./display-field-mandate.vue?vue&type=script&lang=ts&"
export * from "./display-field-mandate.vue?vue&type=script&lang=ts&"
import style0 from "./display-field-mandate.vue?vue&type=style&index=0&id=ccef41b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccef41b4",
  null
  
)

export default component.exports